<template>
  <v-container grid-list-xs>
    <changePass
      @OnPassChange="dialog = $event"
      :dialog="dialog"
      :User="User"
    ></changePass>
    <v-row justify="center">
      <v-col cols="7">
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>List OF Users</v-toolbar-title>
            <v-spacer></v-spacer>
            <addUser :AtFinshed="ShowAllUSers"></addUser>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              flat
              :headers="headers"
              :items="usersList"
              :items-per-page="5"
              class="elevation-1"
            >
              <template v-slot:item.Pass="{ item }">
                <v-btn @click="OnPassChange(item)" icon color="error">
                  <v-icon>fas fa-key</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import addUser from "@/components/Users/AddLoginUser.vue";
import changePass from "@/components/Users/userChangePass.vue";
export default {
  components: { addUser, changePass },
  data() {
    return {
      dialog: false,
      User: null,
      usersList: [],
      headers: [
        {
          text: "User Name",
          align: "left",
          sortable: false,
          value: "UserName",
        },
        { text: "Type", value: "UserType" },
        { text: "Full Name", value: "FullName" },
        { text: "Phone", value: "Userphone" },
        { text: "Pass", value: "Pass" },
      ],
    };
  },
  methods: {
    OnPassChange(user) {
      this.dialog = true;
      this.User = user;
      // console.log(user);
    },
    ShowAllUSers() {
      this.$store
        .dispatch("GET_ONLY", "/users/itus")
        .then(result => {
          this.usersList = result.data;
          // console.log(result);
        })
        .catch(() => {
          // console.log(error);
        });
    },
  },
  mounted() {
    this.ShowAllUSers();
  },
};
</script>
